import { useEffect, useState, useCallback } from "react";
import React from 'react';
import './style.css';

import UserCard from "./UserCard";

//const server = 'http://127.0.0.1:3006';
const server = 'https://pricechat.ru';

export function User(props) {

    const [status, setStatus] = useState(100);
    const [userData, setUserData] = useState({});
    const [q, setQ] = useState(null);

    const fetchData = async () => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const param = params.get('q');
        if (param) {
            let res = await fetch(`${server}/signature?q=${param}`);

            if (res.status === 200) {
                setStatus(200);
                const json = await res.json();
                console.log(json.data);
                setUserData(json.data);
                setQ(param);
            } else {
                setStatus(404);
            }

        }
    }

    useEffect(() => {
        fetchData();
    }, []);


    return (<div className="user-container">
        {
            status === 200 ?
                <UserCard
                    name={userData.name}
                    phone={`+7${userData.phone}`}
                    photo={`${server}/file/${userData.avatar}`}
                    file={`${server}/file/${q}`}
                />
                :
                <h1>404</h1>
        }
    </div>)
}
